module.exports = __webpack_public_path__ + "img/wqdqwdww.009a48a2.png";